"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconSurvey = Experimental__IconSurvey;
exports.IconSurvey = IconSurvey;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconSurvey/index.tsx)
 */
function IconSurvey(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M8 11h8v1.5H8V11zm0-7.5h8V5H8V3.5zm-5 2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM3 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM3 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M13 17h10v2H13v-2zM5.5 9a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 2a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0 10a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 2a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM13 6h10v2H13V6z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconSurvey is deprecated and will be archived soon. Use IconSurvey instead.
 */
function Experimental__IconSurvey(props) {
  return /*#__PURE__*/_react["default"].createElement(IconSurvey, props);
}